import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common';
import { media } from '@/styles/theme';

const ContractRequirementsSkeleton = (): React.ReactElement => <SkeletonContent />;
const ContractRequirementsSkeletonFullWidth = (): React.ReactElement => <SkeletonContentFullWidth />;

export { ContractRequirementsSkeleton, ContractRequirementsSkeletonFullWidth };

const SkeletonContent = styled(SkeletonBlock)`
  height: 100%;
  min-height: 56px;
  margin-bottom: 12px;

  ${media.tablet} {
    height: calc(100% - 32px);
    min-height: 240px;
    margin: 32px 9px;
  }
`;

const SkeletonContentFullWidth = styled(SkeletonBlock)`
  height: 100%;
  min-height: 56px;
  margin-bottom: 12px;

  ${media.tablet} {
    height: 270px;
  }
`;
